// extracted by mini-css-extract-plugin
module.exports = {"sidebar":"TableMenu_sidebar__2CeQY","element":"TableMenu_element__RHTxo","closebtn":"TableMenu_closebtn__2zN1Q","openbtn":"TableMenu_openbtn__128Is"};